module.exports = __webpack_public_path__ + "static/media/Hotel-8@2x.4b41afd2.png";